/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Exactly one system field or arbitrary attribute key.
 */
export type AnalyticsSignalDimension = {
  /**
   * Exact label key, at most 256 UTF-8 bytes; the shared query engine enforces the byte limit.
   */
  attribute?: string | undefined;
  /**
   * System dimension from the analytics catalog: source, role, actor, assistant or definition
   */
  field?: string | undefined;
};

/** @internal */
export const AnalyticsSignalDimension$inboundSchema: z.ZodMiniType<
  AnalyticsSignalDimension,
  unknown
> = z.object({
  attribute: z.optional(z.string()),
  field: z.optional(z.string()),
});
/** @internal */
export type AnalyticsSignalDimension$Outbound = {
  attribute?: string | undefined;
  field?: string | undefined;
};

/** @internal */
export const AnalyticsSignalDimension$outboundSchema: z.ZodMiniType<
  AnalyticsSignalDimension$Outbound,
  AnalyticsSignalDimension
> = z.object({
  attribute: z.optional(z.string()),
  field: z.optional(z.string()),
});

export function analyticsSignalDimensionToJSON(
  analyticsSignalDimension: AnalyticsSignalDimension,
): string {
  return JSON.stringify(
    AnalyticsSignalDimension$outboundSchema.parse(analyticsSignalDimension),
  );
}
export function analyticsSignalDimensionFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsSignalDimension, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsSignalDimension$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsSignalDimension' from JSON`,
  );
}
